import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: white;
}

.wb-brand img {
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.08));
}

.wb-brand-card {
  border: 1px solid rgba(255, 255, 255, 0.82);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 26px rgba(2, 23, 35, 0.16);
}

.wb-brand-dot,
.wb-security-dot {
  display: inline-block;
  width: 0.42rem;
  height: 0.42rem;
  flex: 0 0 auto;
  border-radius: 999px;
}

.wb-brand-dot {
  background: var(--wb-accent, #e96a2c);
  box-shadow: 0 0 0 4px rgba(233, 106, 44, 0.09);
}

.wb-security-dot {
  background: #5bd4a8;
  box-shadow: 0 0 0 4px rgba(91, 212, 168, 0.08);
}

.wb-profile {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.065);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.wb-profile-avatar {
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: linear-gradient(145deg, #1684bd, #006aa6);
  box-shadow: 0 6px 18px rgba(2, 20, 19, 0.2);
}

.wb-profile-action {
  color: rgba(255, 255, 255, 0.68);
}

.wb-profile-action:hover {
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.95);
}

.wb-nav-label {
  color: rgba(255, 255, 255, 0.62);
}

.wb-nav-item {
  position: relative;
  display: flex;
  min-height: 2.45rem;
  align-items: center;
  gap: 0.7rem;
  border: 1px solid transparent;
  border-radius: 0.72rem;
  padding: 0.52rem 0.72rem;
  color: rgba(255, 255, 255, 0.74);
  font-size: 0.8125rem;
  font-weight: 560;
}

.wb-nav-item:hover {
  border-color: rgba(255, 255, 255, 0.09);
  background: rgba(255, 255, 255, 0.08);
  color: white;
}

.wb-nav-item-active {
  border-color: rgba(142, 216, 250, 0.3);
  background: linear-gradient(90deg, rgba(0, 106, 166, 0.46), rgba(0, 106, 166, 0.2));
  color: #ffffff;
}

.wb-nav-item svg {
  width: 1.05rem;
  height: 1.05rem;
  flex: 0 0 auto;
  color: rgba(255, 255, 255, 0.48);
}

.wb-nav-item:hover svg,
.wb-nav-item-active svg {
  color: #8ed8fa;
}

.wb-brand-link:focus-visible,
.wb-profile-action:focus-visible,
.wb-nav-item:focus-visible {
  outline: 3px solid #8ed8fa;
  outline-offset: 2px;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public isActive(link: string, exact: boolean = false) {
        const path = location.pathname.replace(/\/+$/, '') || '/';
        return path === link || (!exact && path.startsWith(`${link}/`));
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    public isAdmin() {
        return this.service.auth?.session?.role === 'admin';
    }

    public activeClass(link: string, exact: boolean = false) {
        if (this.isActive(link, exact)) {
            return "wb-nav-item wb-nav-item-active group";
        }
        return "wb-nav-item group";
    }

    public async logout() {
        const guard = new CustomEvent('ptsd:before-session-end', {
            cancelable: true
        });
        if (!window.dispatchEvent(guard)) return;
        await this.service.request.post('/auth/logout', {
            returnTo: '/access',
            csrf_token: this.service.auth.session?.csrf_token || ''
        });
        location.href = '/access';
    }
}

export default ComponentNavSidebarComponent;